import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/access';
import { ImportsPage } from '@/features/import/page';

export const Route = createFileRoute('/_authenticated/operations/imports')({
  beforeLoad: ({ context, location }) =>
    requirePermission(context.queryClient, location.href, 'imports:read'),
  component: ImportsPage,
});
